module.exports = __webpack_public_path__ + "static/img/bgimg6.6d96fdd1.png";